export const offersListConstants = {
    OFFER_LIST_PENDING  : 'OFFER_LIST_PENDING',
    OFFER_LIST_FULFILLED: 'OFFER_LIST_FULFILLED',
    OFFER_LIST_REJECTED : 'OFFER_LIST_REJECTED',
};
